import type { ComponentType, MutableRefObject } from 'react';
import BrandingOnboarding from './steps/BrandingOnboarding';
import ThemeOnboarding from './steps/ThemeOnboarding';
import HeroOnboarding from './steps/HeroOnboarding';
import AboutOnboarding from './steps/AboutOnboarding';
import ShowcaseOnboarding from './steps/ShowcaseOnboarding';
import MediaOnboarding from './steps/MediaOnboarding';
import PlatformsOnboarding from './steps/PlatformsOnboarding';

import type { BuildResult } from '../../pages/Onboarding';

export interface OnboardingStepProps {
  /** Ref that steps populate with their save function so parent can call it */
  saveRef: MutableRefObject<(() => Promise<void>) | null>;
  /** Step tells the parent whether needed data is valid enough to proceed */
  onValidationChange: (isValid: boolean) => void;
  /** Sends unsaved local state to the current-section website preview. */
  onPreviewChange?: (patch: Record<string, unknown>) => void;
  /** Build result from auto-build flow (available for Hero/About/Showcase steps) */
  buildResult?: BuildResult | null;
  /** Background task status from the build pipeline */
  backgroundStatus?: { musicReady: boolean; socialReady: boolean };
}

export interface OnboardingStepConfig {
  id: string;
  title: string;
  description: string;
  component: ComponentType<OnboardingStepProps>;
  previewMedia: string;
  skippable?: boolean;
}

export const ONBOARDING_STEPS: OnboardingStepConfig[] = [
  {
    id: 'branding',
    title: 'Brand your website',
    description: 'Add your site name, Loader, logo and favicon. This you can change it anytime.',
    component: BrandingOnboarding,
    previewMedia: '/onboarding/branding.svg',
  },
  {
    id: 'hero',
    title: 'Introduce yourself',
    description: 'Tell visitors who you are and what you do.',
    component: HeroOnboarding,
    previewMedia: '/onboarding/hero.svg',
  },
  {
    id: 'about',
    title: 'Tell your story',
    description: 'About yourself, your journey, your inspiration, what drives your craft.',
    component: AboutOnboarding,
    previewMedia: '/onboarding/about.svg',
  },
  {
    id: 'showcase',
    title: 'Your Music Catalog curated from YouTube',
    description: 'You can Add, remove or edit songs. We will fetch the details and thumbnails for you.',
    component: ShowcaseOnboarding,
    previewMedia: '/onboarding/showcase.svg',
  },
  {
    id: 'media',
    title: 'Your Image Gallery curated by you',
    description: 'You can Upload, arrange, or remove photos.',
    component: MediaOnboarding,
    previewMedia: '/onboarding/media.svg',
    skippable: true,
  },
  {
    id: 'platforms',
    title: 'Connect your platforms',
    description: 'Link your social media and streaming profiles so fans can find you everywhere.',
    component: PlatformsOnboarding,
    previewMedia: '/onboarding/platforms.svg',
  },
  {
    id: 'theme',
    title: 'Pick a theme',
    description: 'Choose a look that feels right. You can switch themes later.',
    component: ThemeOnboarding,
    previewMedia: '/onboarding/theme.svg',
  },
];
